import { FC } from 'react';

import { faClose, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import errorSVG from 'assets/svg/error.svg';
import { WRONG_MESSAGE } from 'constants/global';
import { Button, Modal } from 'shared-components';
import ModalControlButtons from 'shared-components/ModalControlButtons';

export interface Props {
  errorMessage?: string;
  isOpen: boolean;
  handleClose: VoidFunction;
  description?: string;
}

const ErrorModal: FC<Props> = ({ errorMessage = WRONG_MESSAGE, description = '', isOpen, handleClose }) => {
  const { t } = useTranslation();

  return (
    <Modal dataCy="error-modal" isOpen={isOpen} isError isDisableOutsideClick hideCross onClose={handleClose}>
      <div className="flex justify-between">
        <div className="flex items-center justify-left">
          <img src={errorSVG} alt="Info icon" className="w-6 h-6" />
          <div className="text-black-900 dark:text-white-00 text-lg ml-3">{t(errorMessage)}</div>
        </div>
        <Button
          dataCy="close-button-icon"
          className="bg-transparent dark:bg-transparent p-0 w-8 h-8 block rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-900 active:bg-neutral-100 dark:active:bg-neutral-900"
          onClick={handleClose}
        >
          <FontAwesomeIcon
            className="w-5 h-5 text-neutral-600 dark:text-neutral-300"
            icon={faClose as IconDefinition}
          />
        </Button>
      </div>

      {description && <div className="text-center mt-4">{t(description)}</div>}

      <ModalControlButtons isError onClose={handleClose} />
    </Modal>
  );
};

export default ErrorModal;
